export default {
  oniku: '#B33D44',
  onikuDark: '#7e001d',
  onikuLight: '#ea6d6f',
}



// WEBPACK FOOTER //
// ./src/variables/colors.jsx